import { render } from "./Invoices.vue?vue&type=template&id=cbacbc74&scoped=true"
import script from "./Invoices.vue?vue&type=script&scoped=true&lang=js"
export * from "./Invoices.vue?vue&type=script&scoped=true&lang=js"

import "./Invoices.vue?vue&type=style&index=0&id=cbacbc74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbacbc74"]])

export default __exports__